import { render, staticRenderFns } from "./WelfareGoodsSearch.vue?vue&type=template&id=574e8fe9&scoped=true"
import script from "./WelfareGoodsSearch.vue?vue&type=script&lang=js"
export * from "./WelfareGoodsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e8fe9",
  null
  
)

export default component.exports